(() => {
  function initialise(scope) {
    scope.querySelectorAll('[data-litq-carousel]').forEach((section) => {
      if (section.dataset.carouselReady) return;
      const track = section.querySelector('.ac-litq__carousel');
      const controls = section.querySelector('.ac-litq__carousel-controls');
      if (!track || !controls) return;
      section.dataset.carouselReady = 'true';
      const previous = controls.querySelector('[data-litq-direction="-1"]');
      const next = controls.querySelector('[data-litq-direction="1"]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        controls.hidden = maximum <= 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      const move = (direction) => {
        const cards = [...track.children];
        const position = track.scrollLeft;
        const origins = cards.map((card) => card.offsetLeft - cards[0].offsetLeft);
        const target = direction > 0
          ? origins.find((origin) => origin > position + 2) ?? track.scrollWidth
          : origins.reverse().find((origin) => origin < position - 2) ?? 0;
        track.scrollTo({ left: target, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-litq-direction]');
        if (button) move(Number(button.dataset.litqDirection));
      });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();

      // Offer one small scroll cue when the cards enter view; user input takes over.
      let cuePending = true;
      let frame;
      let restoreSnap;
      const stopCue = () => {
        cuePending = false;
        cancelAnimationFrame(frame);
        if (restoreSnap) restoreSnap();
        observer?.disconnect();
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || !cuePending) return;
        observer.disconnect();
        cuePending = false;
        if (reducedMotion.matches || track.scrollWidth <= track.clientWidth + 2) return;
        const origin = track.scrollLeft;
        const distance = Math.min(64, track.scrollWidth - track.clientWidth - origin);
        if (distance <= 2) return;
        const snap = track.style.scrollSnapType;
        const behavior = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        restoreSnap = () => {
          track.style.scrollSnapType = snap;
          track.style.scrollBehavior = behavior;
          restoreSnap = null;
          update();
        };
        let started;
        const rock = (time) => {
          started ??= time;
          const progress = Math.min((time - started) / 1400, 1);
          track.scrollLeft = origin + distance * Math.sin(Math.PI * progress) ** 2;
          if (progress < 1) frame = requestAnimationFrame(rock);
          else restoreSnap?.();
        };
        frame = requestAnimationFrame(rock);
      }, { threshold: 0.15 }) : null;
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((name) => {
        section.addEventListener(name, stopCue, { passive: true });
      });
      reducedMotion.addEventListener('change', stopCue);
      observer?.observe(track);
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
